import {BackendModule, ReadCallback} from 'i18next';

import {translations} from '@/../strings';

/**
 * i18next backend that lazily fetches a language's merged resource bundle as a
 * static JSON asset. i18next calls `read` for whichever language it resolves to
 * (initial detection and later `changeLanguage`), so only the needed languages
 * are downloaded. `en` is bundled at init, so `read` only runs for others.
 */
class ResourceLoader implements BackendModule {
  type = 'backend' as const;

  init(): void {
    // No backend options to set up; resources are read on demand.
  }

  read(language: string, _namespace: string, callback: ReadCallback): void {
    const url = translations[language];
    if (!url) {
      callback(null, {});
      return;
    }

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load "${language}": ${response.status}`);
        }

        return response.json();
      })
      .then((resources) => callback(null, resources))
      .catch((error) => callback(error, false));
  }
}

export default ResourceLoader;
